import tinyColor from 'tinycolor2';

import base from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import { ChartColors } from '../../../theme/tokens';

// Heatmap plots a single metric across two dimensions (dimensionA on the y-axis,
// dimensionB on the x-axis), colouring each cell by value. Data is sourced from
// the shared metric-matrix pipeline. Requires the heatmap module (registered in
// Chart.tsx). Colours are derived from the token palette rather than hardcoded.
const heatmap = ({
  formatMetric,
  title,
  xCategories,
  yCategories,
  metricId,
  fontSize,
  openMenu,
  groupField,
  fieldType,
  chartDef,
}) => ({
  ...base(formatMetric),
  chart: {
    ...base(formatMetric).chart,
    type: 'heatmap',
    marginTop: 40,
    marginBottom: 80,
  },
  title: {
    ...base(formatMetric).title,
    text: title,
  },
  legend: {
    enabled: true,
    align: 'right',
    layout: 'vertical',
    verticalAlign: 'top',
    y: 25,
    symbolHeight: 200,
  },
  xAxis: {
    categories: xCategories,
    labels: { style: { fontSize } },
  },
  yAxis: {
    categories: yCategories,
    title: null,
    reversed: true,
    labels: { style: { fontSize } },
  },
  colorAxis: {
    min: 0,
    minColor: tinyColor(ChartColors[0]).lighten(35).toHexString(),
    maxColor: ChartColors[0],
  },
  plotOptions: {
    series: {
      point: {
        events: {
          click: function () {
            const yCategory = yCategories[this.point.y];
            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              openMenu(
                metricIds,
                buildDrillDown(groupField, fieldType, yCategory, chartDef),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              onDrillDown(yCategory);
            }
          },
        },
      },
    },
  },
  tooltip: {
    ...base(formatMetric).tooltip,
    shared: false,
    useHTML: true,
    pointFormatter: function () {
      const value = formatMetric({ metricId, value: this.value });
      const x = xCategories[this.x];
      const y = yCategories[this.y];
      // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables.
      return (
        `<b>${y}</b><br/>` +
        `<span style="color: var(--color-text-muted);">${x}: </span><b>${value}</b>`
      );
    },
  },
});

export default heatmap;
